<div class="dialog-content-wrapper flex flex-col items-start" fusePerfectScrollbar>
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-row justify-between items-center flex-1">
      <span i18n class="title dialog-title">Карта раскроя</span>
      <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="flex flex-auto flex-col justify-center items-center">
    <ng-container>
      <div class="svg-wrapper" [innerHtml]="mapSvg | safeHtml"></div>
    </ng-container>
  </div>

  <!-- <div mat-dialog-actions> -->
  <!-- <button mat-button (click)="dialogRef.close(undefined)">ЗАКРЫТЬ</button> -->
  <!-- </div> -->
</div>
